export const clearPagination = (path: string) => path.split(/page\d+\//gu).join('');

export const findMatch = (path?: string) => path?.match(/page\w+/gu)?.[0];

export const getPageNumber = (pageStr?: string) => (pageStr ? pageStr.split('page').join('') : '');
